__turbopack_context__.v({
  "campusAddress": "CampusList-module__prb2Ta__campusAddress",
  "campusCard": "CampusList-module__prb2Ta__campusCard",
  "campusCardHeader": "CampusList-module__prb2Ta__campusCardHeader",
  "campusCardSelected": "CampusList-module__prb2Ta__campusCardSelected",
  "campusCardTitleRow": "CampusList-module__prb2Ta__campusCardTitleRow",
  "campusDistance": "CampusList-module__prb2Ta__campusDistance",
  "campusDistanceIcon": "CampusList-module__prb2Ta__campusDistanceIcon",
  "campusDistanceText": "CampusList-module__prb2Ta__campusDistanceText",
  "campusLink": "CampusList-module__prb2Ta__campusLink",
  "campusLinks": "CampusList-module__prb2Ta__campusLinks",
  "campusList": "CampusList-module__prb2Ta__campusList",
  "campusListPage": "CampusList-module__prb2Ta__campusListPage",
  "campusListRoot": "CampusList-module__prb2Ta__campusListRoot",
  "campusListRootPage": "CampusList-module__prb2Ta__campusListRootPage",
  "campusName": "CampusList-module__prb2Ta__campusName",
  "campusSelectButton": "CampusList-module__prb2Ta__campusSelectButton",
  "emptyStateSlot": "CampusList-module__prb2Ta__emptyStateSlot",
  "regionCampusList": "CampusList-module__prb2Ta__regionCampusList",
  "regionGroup": "CampusList-module__prb2Ta__regionGroup",
  "regionHeading": "CampusList-module__prb2Ta__regionHeading",
  "searchResultsHeader": "CampusList-module__prb2Ta__searchResultsHeader",
  "showAllCampusesLink": "CampusList-module__prb2Ta__showAllCampusesLink",
});
